import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { ClickOutsideModule } from 'ng-click-outside';

import { AutocompleteModule } from './components/autocomplete/autocomplete.module';
import { PipeModule } from 'app/shared/pipes/pipe.module';

// COMPONENTS
import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { HorizontalMenuComponent } from './horizontal-menu/horizontal-menu.component';
import { VerticalMenuComponent } from './vertical-menu/vertical-menu.component';
import { CustomizerComponent } from './customizer/customizer.component';
import { NotificationSidebarComponent } from './notification-sidebar/notification-sidebar.component';

// DIRECTIVES
import { ToggleFullscreenDirective } from './directives/toggle-fullscreen.directive';
import { SidebarLinkDirective } from './directives/sidebar-link.directive';
import { SidebarDropdownDirective } from './directives/sidebar-dropdown.directive';
import { SidebarAnchorToggleDirective } from './directives/sidebar-anchor-toggle.directive';
import { SidebarDirective } from './directives/sidebar.directive';
import { TopMenuDirective } from './directives/topmenu.directive';
import { TopMenuLinkDirective } from './directives/topmenu-link.directive';
import { TopMenuDropdownDirective } from './directives/topmenu-dropdown.directive';
import { TopMenuAnchorToggleDirective } from './directives/topmenu-anchor-toggle.directive';
import { CardsComponent } from './components/cards/cards.component';
import { DatatableListComponent } from './components/datatable-list/datatable-list.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ApiModule } from './api/api.module';
import { ToursComponent } from './components/tours/tours.component';
import { DateRangeComponent } from './components/date-range/date-range.component';
import { DynamicFormsComponent } from './components/dynamic-forms/dynamic-forms.component';
import { ShowValuesComponent } from './components/dynamic-forms/show-values/show-values.component';
import { NgxMaskModule } from 'ngx-mask';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { ListConfigScheduleComponent } from './components/list-config-schedule/list-config-schedule.component';
import { ArchivosModalComponent } from './components/archivos-modal/archivos-modal.component';
import { LoadingOverlayComponent } from './components/loading-overlay/loading-overlay.component';

@NgModule({
  exports: [
    CommonModule,
    FooterComponent,
    NavbarComponent,
    VerticalMenuComponent,
    HorizontalMenuComponent,
    CustomizerComponent,
    NotificationSidebarComponent,
    ToggleFullscreenDirective,
    SidebarDirective,
    TopMenuDirective,
    NgbModule,
    TranslateModule,
    CardsComponent,
    DatatableListComponent,
    ToursComponent,
    DateRangeComponent,
    DynamicFormsComponent,
    ListConfigScheduleComponent,
    ArchivosModalComponent,
    LoadingOverlayComponent,
    FormsModule,
    ReactiveFormsModule,
    PipeModule,  // ← AGREGAR ESTO

  ],
  imports: [
    RouterModule,
    FormsModule,
    CommonModule,
    NgbModule,
    TranslateModule,
    FormsModule,
    OverlayModule,
    ReactiveFormsModule,
    PerfectScrollbarModule,
    ClickOutsideModule,
    AutocompleteModule,
    PipeModule,
    NgxDatatableModule,
    ApiModule,
    NgxMaskModule,
    NgSelectModule,
    NgxIntlTelInputModule
  ],
  declarations: [

    FooterComponent,
    NavbarComponent,
    VerticalMenuComponent,
    HorizontalMenuComponent,
    CustomizerComponent,
    NotificationSidebarComponent,
    ToggleFullscreenDirective,
    SidebarLinkDirective,
    SidebarDropdownDirective,
    SidebarAnchorToggleDirective,
    SidebarDirective,
    TopMenuLinkDirective,
    TopMenuDropdownDirective,
    TopMenuAnchorToggleDirective,
    TopMenuDirective,
    CardsComponent,
    DatatableListComponent,
    ToursComponent,
    DateRangeComponent,
    DynamicFormsComponent,
    ShowValuesComponent,
    ListConfigScheduleComponent,
    ArchivosModalComponent,
    LoadingOverlayComponent,
  ]
})
export class SharedModule { }
